(function($, window, document, s, undefined){

  imagesLoaded(document, function (){
    var $preloader = $('#site-preloader');

    setTimeout(function removePreloader(){

      $preloader.addClass('done-loading');
      s.$body.removeClass('unscrollable');

      setTimeout(function enableScrolling(){
        $preloader.addClass('hidden');
      }, 800);

    }, 100);
  });

})(jQuery, this, this.document, window.s);
